<template>
    <div v-if="subGroup">
        <div class="rkm-sidebar-list">
            <div class="rkm-sidebar-list-wrap">
                <slot />
            </div>
        </div>
    </div>

    <div v-else>
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        subGroup: { type: Boolean },
    },
}
</script>

<style scoped>
.rkm-sidebar-list {
    background-color: #ffffff;
    border-left: 1px solid #CCCCCC;
    box-shadow: 5px 0 5px -5px #999999;
    height: 100vh;
    left: 100%;
    padding: 5px 0px;
    position: absolute;
    top: 0px;
    width: fit-content;
    white-space: nowrap;
}
.rkm-sidebar-list-wrap {
    height: calc(100% - 56px);
    justify-content: space-between;
    overflow: auto;
}
.rkm-sidebar-list-wrap::-webkit-scrollbar {
    background: transparent;
    width: 2px;
}
.rkm-sidebar-list-wrap::-webkit-scrollbar-track {
    background: none;
    box-shadow: none;
}
.rkm-sidebar-list-wrap::-webkit-scrollbar-thumb {
    background: rgba(0,0,0,0.3);
    border-radius: 10px;
}
</style>